// Directory of recognised input keys
export const SELECT_GEN_RECOGNISED_INPUT = "SELECT GEN RECOGNISED INPUT"
export const MPAN_RECOGNISED_INPUT = "MPAN RECOGNISED INPUT"
export const ADDRESS_INPUT = "ADDRESS RECOGNISED INPUT"
export const SEARCH_DEVICE_RECOGNISED_INPUT = "SEARCH DEVICE RECOGNISED INPUT"
export const G100_SEARCH_RECOGNISED_INPUT_01 = "G100_SEARCH_RECOGNISED_INPUT_01"
export const FIXED_INPUT = "FIXED INPUT"
export const DERIVED_INPUT = "DERIVED INPUT"
export const USER_ACCOUNT_DERIVED_INPUT = "USER ACCOUNT DERIVED INPUT"
export const NESTED_INPUT_FORM_DISCRIMINATED_UNION_01 =
    "NESTED INPUT FORM DISCRIMINATED UNION 01"
export const SINGLE_ATTACHMENT_INPUT_01 = "SINGLE ATTACHMENT INPUT 01"

// Input keys for specific user account inputs
export const USER_ACCOUNT_EMAIL_KW = "USER ACCOUNT EMAIL"
export const USER_ACCOUNT_NAME_KW = "USER ACCOUNT NAME"

// Single instance keys are keys that appear multiple times in the schema
// but should only be rendered once in the form
export const SINGLE_INSTANCE_KEYS = [ADDRESS_INPUT, MPAN_RECOGNISED_INPUT]
